// Small self-contained UI atoms (no store coupling).
import type { ReactNode } from 'react'

export function Logo({ height = 28 }: { height?: number }) {
  return (
    <img src="/reputifly-logo-black.png" alt="Reputifly" draggable={false}
      style={{ height, width: 'auto', userSelect: 'none', WebkitUserDrag: 'none' } as React.CSSProperties} />
  )
}

export function Spinner({ size = 18 }: { size?: number }) {
  return (
    <span role="status" aria-label="Loading" className="rf-spin inline-block"
      style={{ width: size, height: size, border: '2.5px solid var(--color-line-2)', borderTopColor: 'var(--color-primary)', borderRadius: 9999 }} />
  )
}

export function Centered({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-dvh flex items-center justify-center px-5 safe-top safe-bottom" style={{ background: 'var(--color-canvas)' }}>
      {children}
    </div>
  )
}

export function formatBytes(n: number) {
  if (!n || n < 1024) return `${n || 0} B`
  const u = ['KB', 'MB', 'GB']
  let i = -1, v = n
  do { v /= 1024; i++ } while (v >= 1024 && i < u.length - 1)
  return `${v < 10 ? v.toFixed(1) : Math.round(v)} ${u[i]}`
}
